/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ReplyData } from './replyData';


export interface CommunicationData { 
    data?: object;
    replyData?: Array<ReplyData>;
    currentStatus?: string;
    oldStatus?: string;
    sharingFlag?: boolean;
    newCommentFlag?: boolean;
    taskTransition?: boolean;
    actualIndex?: number;
    stepperId?: number;
    lastStepId?: number;
    currentStepId?: number;
    createdAt?: string;
    createdBy?: string;
    updatedAt?: string;
    updatedBy?: string;
}

